import React, { useState, useRef, useCallback, useEffect } from "react";
import Swal from "sweetalert2";
import { useLocation, useHistory, withRouter } from 'react-router-dom';
import { connect } from "react-redux";

import { Tabs, Tab } from "@material-ui/core";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import MobileView from "../../components/design/layout/mobile";
import { AdvertiserCard } from "../../components/ui/advertiser-card";

import { formateDate } from '../../utils/formatDate';

import { TabPanelText,
    WrapperTabs,
    Description,
    DescriptionTitle,
    DescriptionText,
    StoreListItem,
    LoadMoreButton,
    ShowDate } from "./styles";

import OfferService from "../../services/Offer";

import loadImage from "../../utils/LoadImage";
import handleURLParams from "../../utils/handleURLParams";

const DiscountBox = (props) => {

    return (
        <div className="discount-box">
            <div className="top">
                <div className="_cols">
                    <div className="_col">
                        {props.percentOff !== 'undefined%' ?
                            (<div className="percent-off">
                                {props.percentOff} <span>off</span>
                            </div>) : (<></>)
                        }
                    </div>
                    <div className="_col">
                        <div className="infos">
                            <p className="text">
                                {props.text}
                            </p>
                            {props.remainingCoupons >= 0 ? (<p className="small"> Cupons restantes: {props.remainingCoupons} </p>) : (<></>)}
                        </div>

                        <div className="button-action">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

//===============================================================================================================
// #11 - Material UI Set Panel
//===============================================================================================================
const TabPanel = (props) => {

    const { children, value, index, ...other } = props;

    return (

        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    {children}
                </>
            )}
        </div>

    )
}

function Rescue({ website }) {

    const refField = useRef();
    const location = useLocation();
    const history = useHistory();
    const search = new URLSearchParams(location.search);
    const productId = search.get('productId');

    const [tabValue, setTabValue] = useState(0);
    const [couponBlur, setCouponBlur] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);
    const [productCode, setProductCode] = useState(null);
    const [product, setProduct] = useState({});
    const [loadMoreStores, setLoadMoreStores] = useState(3);

    const handleCopyCoupon = () => setCopySuccess(!copySuccess);

    const copyToClipboard = (e) => {
        refField.current.select();
        document.execCommand('copy');
        e.target.focus();

        // Change copy text
        handleCopyCoupon();

        setTimeout(() => {
            setCopySuccess(false)
        }, 2000)
    };

    // * Material UI Tabs
    // * Props Tab
    function tabProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    // * Material UI Tabs
    // * On Change Tab
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleActiveOffer = ({ offerId }) => {
        const offerService = new OfferService();

        offerService.activeOffer({ offerId: offerId }).then((response) => {
            if (response.data.type === 'success') {
                Swal.fire({
                    icon: "success",
                    html: response.data.message,
                    title: "",
                });

                setProductCode(response.data.payload.codigo_oferta);
                setCouponBlur(true);
            } else {
                Swal.fire({
                    icon: "info",
                    html: response.data.message,
                    title: "",
                });
            }
        }).catch(err => {
            Swal.fire({
                icon: "info",
                html: err.response && err.response.data ? err.response.data.message : err.message,
                title: "",
            });
        });
    }

    const hendleSearchProduct = useCallback(() => {
        const offerService = new OfferService();

        if (productId) {
            offerService.findByID({ offerID: productId }).then((response) => {
                setProduct(response.data.payload);
                setProductCode(response.data.payload.codigo_oferta ? response.data.payload.codigo_oferta : null)
                setCouponBlur(response.data.payload.codigo_oferta ? true : false)
            });
        }

    }, [productId]);

    const handleLoadMoreStores = ({ increment = false, decrement = false }) => {

        if (increment) {
            setLoadMoreStores(prev => prev + 3)
        }

        if (decrement) {
            setLoadMoreStores(prev => prev = 3)
        }
    };

    useEffect(() => {
        hendleSearchProduct();
    }, [hendleSearchProduct]);

    useEffect(() => {
        return function cleanup() {
            handleURLParams({
                listOfKeyValues: [
                    { key: 'productId', value: undefined }
                ],
                location: history.location,
                history: history
            })
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="RescuePage">
            <MobileView pageTitle="Voltar" contentMarginTop={46} activeBackHistory className="Wrapper">
                {Object.entries(product).length !== 0 && (
                    <>
                        {product.parceiro ? (
                            <AdvertiserCard
                                storeLogo={loadImage({ imageCode: product.parceiro?.imagem_avatar })}
                                // storeId={product.parceiro?._id}
                                storeTitle={product.parceiro.nome}
                                button={false}
                            />
                        ) : (
                            <AdvertiserCard
                                storeLogo={loadImage({ imageCode: product.empresa?.imagem_avatar })}
                                storeTitle={product.empresa.nome}
                                button={false}
                            />
                        )}

                        <DiscountBox percentOff={`${product.desconto}%`} /*remainingCoupons="0"*/ text={product.titulo} />
                        <div className="_generate-coupon-box">
                            <div className="wrap-field">
                                <div className={couponBlur ? "_field" : "_blur _field"}>
                                    {!couponBlur ? (
                                        "SCAMBCUPOM"
                                    ) : (<input defaultValue={productCode && productCode} ref={refField} className={copySuccess ? "field-coupon" : ""} readOnly />)}
                                </div>

                                {!couponBlur ? (
                                    <button type="button" color="primary" className="see-offer" onClick={() => handleActiveOffer({ offerId: product._id })} >
                                        Gerar cupom
                                    </button>
                                ) : (
                                    <button type="button" color="primary" onClick={copyToClipboard}>
                                        {!copySuccess ? "Copiar" : "Copiado!"}
                                    </button>
                                )}
                            </div>
                            {product.lojas_participantes && 
                                <Description>
                                    <DescriptionTitle>
                                        Lojas participantes
                                    </DescriptionTitle>
                                    <DescriptionText>
                                    {product.lojas_participantes.length > 0 ?
                                        <>
                                            <ul>
                                                {product.lojas_participantes.slice(0, loadMoreStores).map(({ _id, nome }, i) => (
                                                    <>
                                                        <StoreListItem key={`${_id}`}><Icon icon={["fas", "circle"]} />{nome}</StoreListItem>
                                                    </>
                                                ))}
                                            </ul>

                                            {product.lojas_participantes.length > 3 && (loadMoreStores >= product.lojas_participantes.length
                                            ? (
                                                <LoadMoreButton
                                                    type="button"
                                                    textColor={props => props.theme[website]?.pages.offer.priceTextColor} onClick={() => handleLoadMoreStores({ decrement: true })}
                                                >
                                                    Ver menos <Icon icon={["fas", "minus-circle"]} />
                                                </LoadMoreButton>
                                            )
                                            : (
                                                <LoadMoreButton
                                                    type="button"
                                                    textColor={props => props.theme[website]?.pages.offer.callToAction}
                                                    onClick={() => handleLoadMoreStores({ increment: true })}
                                                >
                                                    Ver mais lojas <Icon icon={["fas", "plus-circle"]} />
                                                </LoadMoreButton>

                                            ))}
                                        </>
                                    :   
                                        <>
                                            Nenhuma loja cadastrada.
                                        </>
                                    }
                                    </DescriptionText>
                                </Description>
                            }

                            {product.validade && (
                                <ShowDate>
                                    Oferta válida de <span>{formateDate({ date: product.validade.data_inicio })}</span> até <span>{formateDate({ date: product.validade.data_fim })}</span>
                                </ShowDate>
                            )}
                        </div>


                        <WrapperTabs className="_tabs">
                            <Tabs
                                value={tabValue}
                                onChange={handleChange}
                                aria-label="Tabs My Sales"
                                className={`_material-tabs MaterialTabs style-${website}`}
                            >
                                {product.regras ? (<Tab label="Regras" {...tabProps(0)} />) : (<></>)}
                            </Tabs>

                            {product.regras && product.regras.length > 0 ?
                                (<TabPanel value={tabValue} index={0} className="tabpanel">
                                    {product.regras.map((item, i) => (
                                        <TabPanelText iconColor={props => props.theme[website]?.pages.offer.callToAction} key={`${item}-${i}`}>
                                            <Icon icon={["far", "check"]} />
                                            <p>
                                                {item}
                                            </p>
                                        </TabPanelText>
                                    ))}
                                </TabPanel>) :
                                <DescriptionText>
                                    Nenhuma regra aplicada.
                                </DescriptionText>
                            }

                        </WrapperTabs>
                    </>
                )}
            </MobileView>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(Rescue));